import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function HonestFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const { t } = useTranslation();

  const faqs = [
    { q: t("faq.q1"), a: t("faq.a1") },
    { q: t("faq.q2"), a: t("faq.a2") },
    { q: t("faq.q3"), a: t("faq.a3") },
    { q: t("faq.q4"), a: t("faq.a4") },
  ];

  return (
    <section id="honest-faq" className="w-full bg-paper py-20 md:py-28 scroll-mt-20 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Hand-made%20Japanese%20washi%20paper%20texture%20warm%20off-white%20with%20subtle%20fibers%20and%20soft%20natural%20light%20seamless%20minimal%20no%20text%20no%20objects&width=600&height=600&seq=noren-texture-washi&orientation=squarish')",
          backgroundSize: "cover",
        }}
      ></div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mb-14 md:mb-20">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold mb-4">
            {t("faq.sectionLabel")}
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-[2.75rem] text-ink leading-[1.1] mb-5">
            {t("faq.title")}
            <br />
            <span className="italic font-normal text-ink/70">{t("faq.titleItalic")}</span>
          </h2>
          <p className="text-base text-ink/50 leading-relaxed max-w-xl font-light">
            {t("faq.intro")}
          </p>
        </div>

        <div className="max-w-3xl">
          {faqs.map((faq, i) => (
            <div key={i} className="border-b border-hairline last:border-b-0">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-start justify-between gap-4 py-6 md:py-7 text-left cursor-pointer group"
              >
                <div className="flex items-start gap-4">
                  <span className="text-xs font-medium text-gold mt-1.5 shrink-0 w-5">0{i + 1}</span>
                  <span className="text-sm md:text-base font-medium text-ink group-hover:text-indigo transition-colors duration-300">
                    {faq.q}
                  </span>
                </div>
                <span className="w-8 h-8 border border-hairline flex items-center justify-center shrink-0 group-hover:border-ink/40 transition-colors duration-300 mt-0.5">
                  <i
                    className={`ri-arrow-down-s-line text-ink/40 transition-transform duration-300 ${openIndex === i ? "rotate-180" : ""}`}
                  ></i>
                </span>
              </button>
              {openIndex === i && (
                <div className="pb-6 md:pb-7 pl-9">
                  <p className="text-sm md:text-base text-ink/50 leading-relaxed font-light">
                    {faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}